import { IntlProvider } from 'react-intl';
import { connectToStores } from 'fluxible-addons-react';
import PropTypes from 'prop-types';
import React from 'react';

@connectToStores(['IntlStore'], (context, props) => {
  const intlStore = context.getStore('IntlStore');
  return {
    messages: intlStore.getMessages(),
    locale: intlStore.getCurrentLocale(),
    now: intlStore.getInitialNow(),
    children: props.children
  };
})
class ConnectedIntlProvider extends React.Component {

  static displayName = 'ConnectedIntlProvider';

  static propTypes = {
    messages: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    now: PropTypes.number.isRequired
  };

  render() {
    const { children, messages, locale, now } = this.props;

    return (
      <IntlProvider messages={ messages } locale={ locale } initialNow={ now }>
        { children }
      </IntlProvider>
    );
  }

}

export default ConnectedIntlProvider;



// WEBPACK FOOTER //
// ./src/utils/ConnectedIntlProvider.js